import { z } from "zod";

export const voyadoContactSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().min(1, "Email is required").email("Invalid email address"),
  company: z.string().optional(),
  companyTitle: z.string().optional(),
  countryCode: z.string().length(2, "Country is required"),
  instagramHandle: z.string().optional(),
});

export type VoyadoContact = z.infer<typeof voyadoContactSchema>;
